import React from "react";
import DocumentTitle from "react-document-title";
import { Login } from "../../modules/Login";
import { GridContainer } from "./LoginPage.styles";
import { Grid } from "@mui/material";

export default function LoginPage() {
  return (
    <DocumentTitle title={"Вход - Mindset.Digital"}>
      <GridContainer container justifyContent={"center"} alignItems={"center"}>
        <Grid item>
          <Login />
        </Grid>
      </GridContainer>
    </DocumentTitle>
  );
}
